

document.addEventListener("DOMContentLoaded", function() {
  const intervalId = setInterval(function() {
    const customilyOptions = document.querySelector("#customily-options");
    
    if (customilyOptions) {
      const optionTitle = document.createElement("div");
      optionTitle.className = "option_title text-semibold text-font-body text-capitalize";
      optionTitle.textContent = "Personalized options";
      customilyOptions.prepend(optionTitle);
      clearInterval(intervalId);
    }
  }, 500);
});


document.querySelectorAll("#preview-close, #preview-overlay").forEach(element => {
    element.addEventListener("click", function(e) {
        if (window.innerWidth < 990) {
            const galleryWrap = document.querySelector(".gallery-wrap.gallery-arrows--false.gallery-thumbnails--left.slider-mobile-gutter");
            const canvasWrapper = document.querySelector(".canvas-wrapper");
            const productTitle = document.querySelector(".product_name_title");

            if (galleryWrap && !galleryWrap.querySelector(".canvas-wrapper") && productTitle && productTitle.textContent.includes("Photo")) {
                galleryWrap.prepend(canvasWrapper);
            }
        }
        e.preventDefault();
        document.getElementById("preview-container").classList.toggle("hidden");
    });
});

function checkValid() {
    document.querySelectorAll("form #customily-options .swatch-container").forEach(container => {
        const checked = container.querySelector('input[type="radio"]:checked');
        const customilyOption = container.closest(".customily_option");
        const requiredLabel = customilyOption.querySelector(".customily-required-label span");

        if (checked) {
            customilyOption.classList.remove("customily-required-error");
            requiredLabel.style.display = "none";
        } else {
            customilyOption.classList.add("customily-required-error");
            requiredLabel.style.display = "block";
        }
    });

    document.querySelectorAll("form #customily-options select").forEach(select => {
        const customilyOption = select.closest(".customily_option");
        const requiredLabel = customilyOption.querySelector(".customily-required-label span");

        if (select.value) {
            customilyOption.classList.remove("customily-required-error");
            requiredLabel.style.display = "none";
        } else {
            customilyOption.classList.add("customily-required-error");
            requiredLabel.style.display = "block";
        }
    });

    document.querySelectorAll('form #customily-options input[type="text"]').forEach(input => {
        const customilyOption = input.closest(".customily_option");
        const requiredLabel = customilyOption.querySelector(".customily-required-label span");

        if (input.value.length) {
            customilyOption.classList.remove("customily-required-error");
            requiredLabel.style.display = "none";
        } else {
            customilyOption.classList.add("customily-required-error");
            requiredLabel.style.display = "block";
        }
    });

    document.querySelectorAll("form #customily-options textarea").forEach(textarea => {
        const customilyOption = textarea.closest(".customily_option");
        const requiredLabel = customilyOption.querySelector(".customily-required-label span");

        if (textarea.value.length) {
            customilyOption.classList.remove("customily-required-error");
            requiredLabel.style.display = "none";
        } else {
            customilyOption.classList.add("customily-required-error");
            requiredLabel.style.display = "block";
        }
    });

    document.querySelectorAll("form #customily-options .customily-file-input").forEach(fileInput => {
        const checked = fileInput.querySelector(".cl_remove-image").offsetParent !== null;
        const customilyOption = fileInput.closest(".customily_option");
        const requiredLabel = customilyOption.querySelector(".customily-required-label span");

        if (checked) {
            customilyOption.classList.remove("customily-required-error");
            requiredLabel.style.display = "none";
        } else {
            customilyOption.classList.add("customily-required-error");
            requiredLabel.style.display = "block";
        }
    });
}

document.querySelectorAll("#btn-preview, #btn-preview-desktop").forEach(button => {
    button.addEventListener("click", function(e) {
        e.preventDefault();
        checkValid();

        const customilyOptions = document.querySelectorAll(".customily_option");
        const firstError = Array.from(customilyOptions).find(option => 
            option.classList.contains("customily-required-error") && 
            window.getComputedStyle(option).display !== "none"
        );

        if (firstError) {
            document.getElementById("preview-container").style.display = "none";
            const errorInput = firstError.querySelector("input, select, textarea");
            if (errorInput) errorInput.focus();
            const header = document.querySelector("header");
            const topOffset = header ? header.offsetHeight : 80;
            const errorPosition = firstError.getBoundingClientRect().top + window.scrollY - topOffset;
            window.scrollTo({ top: errorPosition, behavior: "smooth" });
            return;
        }

        if (window.innerWidth < 992) {
            const productTitle = document.querySelector(".product_name_title");
            if (productTitle && productTitle.textContent.includes("Photo")) {
                const canvasWrapper = document.querySelector(".canvas-wrapper");
                const previewImageWrap = document.querySelector(".preview-image-wrap");
                previewImageWrap.innerHTML = "";
                previewImageWrap.append(canvasWrapper);
            }
           const previewCanvas = document.getElementById("preview-canvas");
            if (previewCanvas) {
                const dataURL = previewCanvas.toDataURL();
                const previewImg = document.getElementById("preview-img");
                previewImg.setAttribute("src", dataURL);
            }
        } else {
            const previewCanvas = document.getElementById("preview-canvas");
            if (previewCanvas) {
                const dataURL = previewCanvas.toDataURL();
                const previewImg = document.getElementById("preview-img");
                previewImg.setAttribute("src", dataURL);
            }
        }

        const previewContainer = document.getElementById("preview-container");
        previewContainer.classList.remove("hidden");
        previewContainer.style.display = "block";
    });
});

document.getElementById("customily-cart-btn-preview").addEventListener("click", function() {
    const customilyCartBtn = document.getElementById("customily-cart-btn");
    if (customilyCartBtn) {
        customilyCartBtn.click();
    } else {
        console.warn("#customily-cart-btn không tồn tại.");
    }
});




